import React from "react"
import { ADD, LIST, TOGGLE_VIEW } from "constants/index"
import { NAVIGATE_TO_CREATE_ITEM_PAGE, SWITCH_LIST_ITEM_VIEW_MODE } from "constants/events"
import AddIcon from "components/atoms/_icons/AddIcon"
import HorizontalSliderIcon from "components/atoms/_icons/HorizontalSliderIcon"
import VerticalRowIcon from "components/atoms/_icons/VerticalRowIcon"

const notFoundListHeaderButtons = {
  right: [],
  left: []
}

const nonEmptyListHeaderButtonsForListView = {
  right: [
    { icon: <AddIcon/>, eventName: NAVIGATE_TO_CREATE_ITEM_PAGE, key: ADD },
    { icon: <HorizontalSliderIcon/>, eventName: SWITCH_LIST_ITEM_VIEW_MODE, key: TOGGLE_VIEW }
  ],
  left: []
}

const nonEmptyListHeaderButtonsForItemView = {
  right: [
    { icon: <AddIcon/>, eventName: NAVIGATE_TO_CREATE_ITEM_PAGE, key: ADD },
    { icon: <VerticalRowIcon/>, eventName: SWITCH_LIST_ITEM_VIEW_MODE, key: TOGGLE_VIEW }
  ],
  left: []
}

const emptyListHeaderButtons = {
  right: [
    { icon: <AddIcon/>, eventName: NAVIGATE_TO_CREATE_ITEM_PAGE, key: ADD }
  ],
  left: []
}

export function getHeaderButtons(listInfo: WishList | null, viewMode: ViewMode) {
  if (listInfo) {
    if (listInfo.listItems?.length) {
      return viewMode === LIST ? nonEmptyListHeaderButtonsForListView : nonEmptyListHeaderButtonsForItemView
    } else {
      return emptyListHeaderButtons
    }
  } else {
    return notFoundListHeaderButtons
  }
}
